import { PostProcessorModule } from 'i18next';

import { StorageService, StorageType, WindowRefService, hasOwnProp } from '@hdms/shared/util-core';

const PROCESSOR_NAME = 'debugKeysOutput';

/**
 * i18next post-processor returning correctly namespaced translation keys for debugging purpose.
 * Workaround as i18next even in ci-mode is not capable to output translation key
 * and its related namespace without falling back to default namespace.
 * Only activated when adding query parameter "?showMessageCode=true".
 */
export const debugKeysOutputProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: PROCESSOR_NAME,
  process: (_value, key, _options, translator) => {
    const { options } = translator;
    const translationKey = key[key.length - 1];
    const keys = translationKey.split(options.keySeparator);
    const allNsData = translator.resourceStore.data[options.fallbackLng || options.lng];

    let validNameSpace = '';

    for (const nsKey in allNsData) {
      if (hasOwnProp(allNsData, nsKey)) {
        const val = keys.reduce((acc, curr) => acc && curr && acc[curr], allNsData[nsKey]);
        if (val) {
          validNameSpace = nsKey;
          break;
        }
      }
    }

    return `${validNameSpace}${options.nsSeparator}${translationKey}`;
  }
};

export function getDebugKeysOutputProcessor(
  isBrowser: boolean,
  { nativeWindow }: WindowRefService,
  storageService: StorageService
): false | string[] {
  let showMessageCode = false;

  if (isBrowser) {
    const showMessageCodeParam = 'showMessageCode';

    const searchParams = new URL(nativeWindow.location.href).searchParams;
    if (searchParams.has(showMessageCodeParam)) {
      searchParams.get(showMessageCodeParam) === 'true'
        ? storageService.setItem(showMessageCodeParam, true, StorageType.SESSION)
        : storageService.removeItem(showMessageCodeParam, StorageType.SESSION);
    }
    showMessageCode = storageService.getItem(showMessageCodeParam, StorageType.SESSION);
  }

  return showMessageCode && [PROCESSOR_NAME];
}
